
import { defineComponent } from 'vue'

export default defineComponent({
  emits: ['prev', 'next'],
  setup(prop, { emit }) {
    return { emit }
  }
})
